function padTo2Digits(num: number) {
  return num.toString().padStart(2, '0');
}

type ConvertMsToTimeOptions = {
  seconds?: boolean;
  minutes?: boolean;
  hours?: boolean;
};

export function convertMsToTime(milliseconds: number, options?: ConvertMsToTimeOptions) {
  const showSeconds = options?.seconds ?? true;
  const showMinutes = options?.minutes ?? true;
  const showHours = options?.hours ?? false;

  let seconds = Math.floor(milliseconds / 1000);
  let minutes = Math.floor(seconds / 60);
  let hours = Math.floor(minutes / 60);

  seconds = seconds % 60;
  minutes = minutes % 60;

  // 👇️ If you don't want to roll hours over, e.g. 24 to 00
  // 👇️ comment (or remove) the line below
  // commenting next line gets you `24:00:00` instead of `00:00:00`
  // or `36:15:31` instead of `12:15:31`, etc.
  hours = hours % 24;

  let str = '';

  if (showHours) {
    str += padTo2Digits(hours);
  }

  if (showMinutes) {
    if (str.length > 0) {
      str += ':';
    }

    str += `${padTo2Digits(minutes)}`;
  }

  if (showSeconds) {
    if (str.length > 0) {
      str += ':';
    }

    str += `${padTo2Digits(seconds)}`;
  }

  return str;
}
